interface HrPositionRaw {
  id: number
  name: string
  department_id?: number
}

// /api/occupations answers with a bare array; the { data: [...] } shape is
// kept as a fallback in case a paginated variant is ever swapped in.
export type GetHrPositionsRaw = HrPositionRaw[] | { data?: HrPositionRaw[] }
